import React from 'react';
import PropTypes from 'prop-types';

import SplitText from '../SplitText';

const Standard = ({ content }) => {
  return <SplitText>{content.text}</SplitText>;
};

Standard.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired
};

export default Standard;
